import axios from "axios";
import { environment } from "../../../environment";
export const url = (invitationId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/sharing/${invitationId}`
    : `https://middleware.uat.farther.com/sharing/${invitationId}`;
export default async function deleteInvitation(invitationId, idempotencyKey, config) {
    await axios.delete(url(invitationId), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...("advisorId" in config && { Advisor: config.advisorId }),
            "Idempotency-key": idempotencyKey,
            Version: "20240606",
        },
    });
}
//# sourceMappingURL=deleteInvitation.js.map